//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCiudades } from "@/typings/store/plugins/easyFirestore/ciudades";

const getters: GetterTree<StateCiudades, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const ciudades = {
    firestorePath: "dev/v1/ciudades",
    firestoreRefType: "collection",
    moduleName: "ciudades",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default ciudades;
